import { createFileRoute } from '@tanstack/react-router'
import { FileHealthPanel } from '../../components/FileHealthPanel'

export const Route = createFileRoute('/dev/file-health')({
  component: FileHealthPanel,
})
